import { UserProfile } from "../../../states/user";
import * as S from "./InfoForm.styles";
import { ReactComponent as IconCopy } from "../../../styles/assets/svg/icon-copy.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { useNavigate } from "react-router";

type InfoFormProps = {
  data: UserProfile;
};

export const InfoForm = ({ data }: InfoFormProps) => {
  const navigate = useNavigate();
  return (
    <S.InfoForm>
      <S.InfoDetail>
        <S.InfoSpan> 기본정보 </S.InfoSpan>
        <S.InfoGroup>
          <S.Infointo>회원번호</S.Infointo>
          <S.InfoContext className="idText">{data?.id}</S.InfoContext>
          <S.InfoFunction>
            <CopyToClipboard
              text={data?.id}
              // onCopy={() => alert("복사되었습니다.")}
            >
              <IconCopy fill="#1D4ED7" width={21} height={21} />
            </CopyToClipboard>
          </S.InfoFunction>
        </S.InfoGroup>
        <S.InfoGroup>
          <S.Infointo>휴대폰 </S.Infointo>
          <S.InfoContext>{data?.phoneNumber}</S.InfoContext>
        </S.InfoGroup>
        <S.InfoGroup>
          <S.Infointo>이메일 </S.Infointo>
          <S.InfoContext>{data?.email}</S.InfoContext>
        </S.InfoGroup>
      </S.InfoDetail>
      <hr />
      <S.InfoDetail onClick={() => navigate("/withdrawal")}>
        <S.WithDrawalInfoSpan> 회원 탈퇴 </S.WithDrawalInfoSpan>
      </S.InfoDetail>
    </S.InfoForm>
  );
};
